import { CSSProperties } from "vue";
import bridge from "@clover/bridge";
import { CheckPageEnv } from "@clover/ashe-libs";

const url_params = new URLSearchParams(location.search);

export const sendLog = (
  type: "clk" | "exp" | "pv" | "pef",
  name: string,
  params: Record<string, any>
) => {
  if (type === "pv" && url_params.get("chanel_params")) {
    params = { ...params, chanel_params: url_params.get("chanel_params") };
  }
	if (CheckPageEnv() === "inner") {
    if (type === 'pv') {
      bridge.trackEvent(type, name, {
        par: params
      });
    } else {
      bridge.trackEvent(type as any, name, { ...params });
    }
	} else {
    if (type === 'pv') {
      window.SA.sendPv(name, { activity_page_id: params.activity_page_id })
    } else {
      window.SA.report({
        event: name,
        type: type,
        payload: params,
      });
    }
  }
};
